import { useEffect, useState } from "react";
import { BasePageContainer } from "../../components/common";
import ResizableTable from "./components/common/ResizableTable";
import { getDashboardData } from "../../service/ai-model.service";
import { DashboardViewType } from "../../helper/constant";
import { useAppContext } from "../../context/app.context";
import CustomLoader from "../../components/common/CustomLoader";

const Business360Page = () => {

  const { activeDashboardVersion, business360Data, updateBusiness360Data } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (activeDashboardVersion) {
      setIsLoading(true);
      const param = new URLSearchParams(window.location.search);
      const org = param.get('org');

      getDashboardData({ type: DashboardViewType.DASHBOARDS, org, versionId: activeDashboardVersion })
        .then((result) => {
          if (result && result.data) {
            updateBusiness360Data([result.data]);
          } else {
            updateBusiness360Data([])
          }
        }).catch((e) => e)
        .finally(() => setIsLoading(false));
    }
  }, [activeDashboardVersion])

  const renderBusinessTable = () => {
    if (business360Data && business360Data.length) {
      return <ResizableTable />
    }
    return <h4 className="d-flex flex-column align-items-center justify-content-center h-100vh" >No data available</h4>
  }

  return (
    <div className="row mx-0 loginwrap">
      {isLoading && <CustomLoader full />}
      <BasePageContainer>
        {renderBusinessTable()}
      </BasePageContainer>
    </div>
  );
};

export default Business360Page;
